import { Tooltip } from "@blueprintjs/core";
import React from "react";

import VerticalCenter from "common/fragments/VerticalCenter";
import { IViewProps, View } from "core/decorators/View";
import { clamp } from "core/util/MathUtils";
import ProgressBarViewConfig from "./ProgressBarConfig";

/**
 * progress bar or circle
 */

interface IProgressBarProps extends IViewProps<ProgressBarViewConfig> {
	label?: string | JSX.Element;
	value: number; // 0 to 1
}

export enum ProgressBarVariant {
	DEFAULT = "default"
}

const styles: any = {
	circleWrapper: {
		display: 'inline-block',
		position: 'relative'
	},
	circleLabel: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	}
};

@View({id: "progress-bar", configClass: ProgressBarViewConfig, variants: ProgressBarVariant})
export default class ProgressBarView extends React.PureComponent<IProgressBarProps> {

	public render() {
		const { config, label, style, value } = this.props;

		const val = clamp(0, 1, value, 0);

		const bg = config.backgroundColor || "#f1f1f1";
		const barBg = config.barBackgroundColor || "#4ed0d0";

		if (config.circle) {

			const h = config.circleSize && config.circleSize > 0 ? config.circleSize : 120;
			const size = h / 2;
			const stroke = config.strokeWidth > 0 && config.strokeWidth || 4;
			const r = size - stroke;
			const circ = r * Math.PI * 2;

			const circleProps = { r, cx: size, cy: size, strokeWidth: stroke, fill: "transparent", strokeDasharray: circ + ' ' + circ };

			const circleEl = (
				<div style={styles.circleWrapper}>
					<svg height={h} width={h}>
						<circle
							{...circleProps}
							style={{
								stroke: bg
							}}
						/>
						<circle
							{...circleProps}
							style={{
								transition: config.animate ? "stroke-dashoffset 0.2s" : undefined,
								stroke: barBg,
								strokeDashoffset: circ - val * circ,
								transform: 'rotate(-90deg)',
								transformOrigin: '50% 50%'
							}}
						/>
					</svg>
					{(config.labelPosition === 'on' && label) && (
						<VerticalCenter style={styles.circleLabel}>
							{label}
						</VerticalCenter>
					)}
				</div>
			);

			if (label && config.labelPosition === 'tooltip') {
				return (
					<div style={style}>
						<Tooltip content={label}>
							{circleEl}
						</Tooltip>
					</div>
				);
			}

			if (label && config.labelPosition === 'below') {
				return (
					<div style={style}>
						{circleEl}
						<div style={{paddingTop: "5px"}}>
							{label}
						</div>
					</div>
				);
			}

			return (
				<div style={style}>
					{circleEl}
				</div>
			);
		}

		const element = (
			<div style={{backgroundColor: bg, position: 'relative', height: config.height, margin: config.margin}}>
				<div
					style={{
						width: (val * 100) + '%',
						backgroundColor: barBg,
						position: 'absolute',
						top: 0,
						left: 0,
						bottom: 0,
						transition: config.animate ? 'width 0.2s' : undefined
					}}
				>
					{config.labelPosition === 'on' && label && (
						<VerticalCenter style={{color: config.labelColor || "#000", height: '100%', overflow: 'hidden'}}>
							{label}
						</VerticalCenter>
					)}
				</div>
			</div>
		);

		if (label) {
			if (config.labelPosition === 'tooltip') {
				return (
					<Tooltip content={label}>
						<div style={style}>
							{element}
						</div>
					</Tooltip>
				);
			}

			if (config.labelPosition === 'below') {
				return (
					<div style={style}>
						{element}
						<div style={{paddingTop: "5px"}}>
							{label}
						</div>
					</div>
				);
			}
		}

		return (
			<div style={style}>{element}</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/progressBar/ProgressBar.view.tsx